import React, { FunctionComponent, useState } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { store } from "react-notifications-component"
import { Route, useHistory, useRouteMatch } from "react-router"
import { notificationOptions } from "../../../api/Definitions"
import { iArtifact } from "../../../definitions/Artifacts"
import { post } from "../../../store/data/actions"
import ArtifactHeader from "../Header"
import ArtifactDetails from "../inspector/Details"
import ArtifactOverview from "../inspector/Overview"
import ArtifactUploads from "../inspector/Uploads"

const CreateArtifact: FunctionComponent = () => {
  const [isLoading, setLoading] = useState(false)
  const history = useHistory()
  const match = useRouteMatch()
  const methods = useForm({ shouldUnregister: false })

  const onSubmit = (data: iArtifact) => {
    setLoading(true)
    post<iArtifact>({ link: "/v1/create-artifact", data }).then((artist) => {
      setLoading(false)
      history.push("/artifacts/" + artist.url)
      store.addNotification({
        title: "Success!",
        message: "Artifact successfully created!",
        type: "success",
        ...notificationOptions,
      })
    })
  }

  return (
    <FormProvider {...methods}>
      <ArtifactHeader
        isLoading={isLoading}
        title="Create Artifact"
        submitDeleteText={"Delete"}
        submitText={"Create"}
        handleSubmit={() => {
          methods.handleSubmit((data) => {
            onSubmit(data as iArtifact)
          })()
        }}
      />
      <div className="inspector">
        <form
          onSubmit={methods.handleSubmit((data) => {
            onSubmit(data as iArtifact)
          })}
          className="inspector-form"
        >
          <Route exact path={match.path}>
            <ArtifactOverview />
          </Route>
          <Route exact path={match.path + "/details"}>
            <ArtifactDetails />
          </Route>
          <Route exact path={match.path + "/manage-files"}>
            <ArtifactUploads />
          </Route>
          <button type="submit" className="btn-blue d-none">
            Save Changes
          </button>
        </form>
      </div>
    </FormProvider>
  )
}

export default CreateArtifact
